const api = {
    // hqyzmkey: '/login/hqyzmkey', //获取图片验证码
    // createtpyzm: '/login/createtpyzm', //获取图片验证码
    ptglylogin: '/login/ptglylogin',  //总管理员登录
    zhucezh: '/login/zhucezh',  //注册
    genggaimima: '/user/genggaimima',  //总管理员修改密码
    addchanpinjh: '/yuangong/addchanpinjh',  //添加商品
    getcpjhlist: '/yuangong/getcpjhlist',  //获取商品列表
    editchanpinjh: '/yuangong/editchanpinjh',  //编辑商品
    delchanpinjh: '/yuangong/delchanpinjh',  //删除商品
    ckszdqmrhh: '/yuangong/ckszdqmrhh',  //获取默认货号
    userlist: '/user/userlist',  //用户列表
    edituser: '/user/edituser',  //修改用户
    deluser: '/user/deluser',  //删除用户
    usersmyinfo: '/yuangong/usersmyinfo',  //获取用户信息
    editmyinfo: '/yuangong/editmyinfo',  //修改用户信息
    
    getcpjhary: '/yuangong/getcpjhary',  //获取商品列表
    addcpyongliao: '/yuangong/addcpyongliao',  //添加表格
    cpcailiaolist: '/yuangong/cpcailiaolist',  //获取表格列表
    editcpcailiao: '/yuangong/editcpcailiao',  //修改表格
    delcpcailiao: '/yuangong/delcpcailiao',  //删除表格

    getcpjhinfo: '/yuangong/getcpjhinfo',  //获取商品数据
    getcpcailiaoary: '/yuangong/getcpcailiaoary',  //获取裁片列表
    addclyongliang: '/yuangong/addclyongliang',  //添加裁片数据
    editclyongliang: '/yuangong/editclyongliang',  //编辑裁片数据
    delclyongliang: '/yuangong/delclyongliang',  //编辑裁片数据
    clyonglianglist: '/yuangong/clyonglianglist',  //获取裁片数据
    
    
    showcpjhxq: '/yuangong/showcpjhxq',  //获取成本核算数据

    addcaigoujh: '/yuangong/addcaigoujh',  //添加采购单
    caigojhlist: '/yuangong/caigojhlist',  //采购单列表
    doeditcaigoujh: '/yuangong/doeditcaigoujh',  //编辑采购单
    delcaigoujh: '/yuangong/delcaigoujh',  //删除采购单

    caigoujhxiangqing: '/yuangong/caigoujhxiangqing',  //采购明细数据


    getwzjibenset: '/index/getwzjibenset',  //基本数据获取
    editwzjbset: '/user/editwzjbset',  //保存基本数据

    ckyhdcpjhlist: '/yuangong/ckyhdcpjhlist',  //用户产品材料列表

}


export default api